import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class OrgRoleEditValidator {

    position = [
        Validators.required
    ];

    urole_id = [
        Validators.required
    ]

    department = [
        Validators.required
    ]

    // Error messages
    errorMessages = {
        urole_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        department_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        position_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}